import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";

@Injectable({
  providedIn: "root",
})
export class StorageService extends Storage {
  ready: Promise<Storage>;
  _storage: Storage | undefined;

  constructor() {
    super();
    this.ready = this.create().then((s) => (this._storage = s));
  }

  override async get(key: string): Promise<any> {
    if (!this._storage) await this.ready;
    return super.get(key);
  }

  override async set(key: string, value: any): Promise<any> {
    if (!this._storage) await this.ready;
    return super.set(key, value);
  }

  override async remove(key: string): Promise<any> {
    if (!this._storage) await this.ready;
    return super.remove(key);
  }

  override async clear(): Promise<void> {
    if (!this._storage) await this.ready;
    return super.clear();
  }

  override async length(): Promise<number> {
    if (!this._storage) await this.ready;
    return super.length();
  }

  override async keys(): Promise<string[]> {
    if (!this._storage) await this.ready;
    return super.keys();
  }

  override async forEach(
    iteratorCallback: (value: any, key: string, iterationNumber: Number) => any
  ): Promise<void> {
    if (!this._storage) await this.ready;
    return super.forEach(iteratorCallback);
  }
}
